import { makeMenuIcon } from '@/lib/menuIcons'
import type { SidebarTab } from '@shared/ui/layout'

export function getTenantAdminCategoryOrder(locale: string): string[] {
  return locale === 'en' ? ['Operations', 'Access', 'Integrations'] : ['운영 현황', '조직·권한', '연동']
}

export function getTenantAdminTabs(locale: string): SidebarTab[] {
  const en = locale === 'en'
  const operations = en ? 'Operations' : '운영 현황'
  const access = en ? 'Access' : '조직·권한'
  const integrations = en ? 'Integrations' : '연동'
  return [
    {
      id: 'overview',
      label: en ? 'Overview' : '개요',
      icon: makeMenuIcon('tnad-overview'),
      href: '/tenant-admin/overview',
      labelType: [operations],
    },
    {
      id: 'monitoring',
      label: en ? 'Monitoring' : '모니터링',
      icon: makeMenuIcon('tnad-monitor'),
      href: '/tenant-admin/monitoring',
      labelType: [operations],
    },
    {
      id: 'organization',
      label: en ? 'Organization' : '조직/사용자',
      icon: makeMenuIcon('tnad-org'),
      href: '/tenant-admin/organization',
      labelType: [access],
    },
    {
      id: 'authentication',
      label: en ? 'User authentication' : '사용자 인증',
      icon: makeMenuIcon('tnad-auth'),
      href: '/tenant-admin/authentication',
      labelType: [access],
    },
    {
      id: 'menu-management',
      label: en ? 'Menu management' : '메뉴관리',
      icon: makeMenuIcon('tnad-menu'),
      href: '/tenant-admin/menu-management',
      labelType: [access],
    },
    {
      id: 'access-control',
      label: en ? 'Access control' : '접근제어',
      icon: makeMenuIcon('tnad-access'),
      href: '/tenant-admin/access-control',
      labelType: [access],
    },
    {
      id: 'mcp',
      label: en ? 'MCP' : 'MCP 연동',
      icon: makeMenuIcon('tnad-mcp'),
      href: '/tenant-admin/mcp',
      labelType: [integrations],
    },
    {
      id: 'integrations',
      label: 'Connectors',
      icon: makeMenuIcon('tnad-connectors'),
      href: '/tenant-admin/integrations',
      labelType: [integrations],
    },
    {
      id: 'identity',
      label: en ? 'Identity settings' : '인증 설정',
      icon: makeMenuIcon('tnad-identity'),
      href: '/tenant-admin/identity',
      labelType: [integrations],
    },
  ]
}

/** @deprecated use getTenantAdminTabs */
export const tenantAdminTabs: SidebarTab[] = getTenantAdminTabs('ko')
